import DragElement from "./DragElement";

export default class DragSelected extends DragElement {
  dragType = "DragSelected";
}
